import { Checkbox, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { TableCellCustom } from '@app/components/table';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { RowActions } from './row-actions';
import { IAttribute } from '../types';

interface Props {
  row: IAttribute;
  selected: boolean;
  onSelectRow: (id: number) => void;
}
const Row = (props: Props) => {
  const { row, selected, onSelectRow } = props;
  const location = useLocation();
  const currentPathname = location.pathname;

  return (
    <>
      <TableCellCustom>
        {currentPathname === PATH_DASHBOARD.attribute ? (
          <Typography variant="body2">{row.id}</Typography>
        ) : (
          <Checkbox
            checked={selected}
            onChange={() => {
              onSelectRow(row.id);
            }}
          />
        )}
      </TableCellCustom>

      <TableCellCustom flex>
        <Typography variant="body2">{row.name}</Typography>
      </TableCellCustom>
      <TableCellCustom align="left">
        <Checkbox key={row.id} checked={row?.isPrefix} />
      </TableCellCustom>
      <TableCellCustom align="left">
        <Checkbox key={row.id} checked={row?.showAsFilter} />
      </TableCellCustom>

      <TableCellCustom align="right" width={50}>
        <RowActions row={row} showActions={currentPathname === PATH_DASHBOARD.attribute} />
      </TableCellCustom>
    </>
  );
};

export { Row };
